import React from 'react';

import { Box, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

type MarkdownProps = {
  md: string;
  textVariant:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'caption'
    | 'button'
    | 'overline';
  color?: 'text.secondary' | 'text.primary' | 'inherit';
  LinkComponent: React.FC<
    React.PropsWithChildren<{ href: string; external?: boolean }>
  >;
  className?: string;
};

const createRenderers = (
  textVariant: MarkdownProps['textVariant'],
  color: MarkdownProps['color'],
  LinkComponent: MarkdownProps['LinkComponent'],
) => ({
  paragraph: ({ children }: any) => (
    <Typography variant={textVariant} color={color}>
      {children}
    </Typography>
  ),

  link: ({ href, children }: any) => (
    <LinkComponent href={href} external>
      {children}
    </LinkComponent>
  ),

  list: ({ ordered, children }: any) => {
    const Tag = ordered ? 'ol' : 'ul';
    return (
      <Tag style={{ paddingLeft: '1.3em', marginBlock: 0 }}>{children}</Tag>
    );
  },

  listItem: ({ children }: any) => (
    <Box color={color}>
      <li>
        <Typography variant={textVariant} color={color}>
          {children}
        </Typography>
      </li>
    </Box>
  ),
});

export const Markdown = ({
  md,
  textVariant = 'body2',
  color = 'text.secondary',
  LinkComponent,
  className,
}: MarkdownProps) => {
  return (
    <ReactMarkdown
      renderers={createRenderers(textVariant, color, LinkComponent)}
      className={className}
    >
      {md}
    </ReactMarkdown>
  );
};
